/**
 * Light haptics for mobile remote (navigator.vibrate). No-ops when unavailable.
 */

function safeVibrate(pattern: number | number[]): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(pattern);
  } catch {
    /* ignore */
  }
}

/** Short tap when sending a reaction or on incoming chat (subtle “tick”). */
export function lecturaHapticLightTick(): void {
  safeVibrate(12);
}

/** Slightly softer tick for chat notification (can feel distinct from emote). */
export function lecturaHapticChatIncoming(): void {
  safeVibrate(10);
}
